var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.9866V15.4932C3 18.3257 3 19.742 3.87868 20.622C4.75736 21.502 6.17157 21.502 9 21.502H15C17.8284 21.502 19.2426 21.502 20.1213 20.622C21 19.742 21 18.3257 21 15.4932V10.9866",
    stroke: "#101010",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.9741H11",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7967 2.50049L6.1508 2.52954C4.41263 2.44011 3.96697 3.77859 3.96697 4.4329C3.96697 5.01809 3.89152 5.8712 2.82621 7.47462C1.7609 9.07804 1.84095 9.55437 2.44168 10.6644C2.94025 11.5857 4.20838 11.9455 4.86959 12.0061C6.9698 12.0538 7.99162 10.2398 7.99162 8.96495C9.03348 12.1683 11.9965 12.1683 13.3168 11.802C14.6395 11.435 15.7727 10.1214 16.0401 8.96495C16.196 10.4021 16.6692 11.2408 18.0673 11.817C19.5155 12.4139 20.7609 11.5016 21.3858 10.9168C22.0106 10.332 22.4117 9.03364 21.2977 7.60666C20.5295 6.62257 20.2094 5.69548 20.1042 4.73462C20.0433 4.17787 19.9898 3.57961 19.5981 3.1989C19.0257 2.64253 18.2045 2.47372 17.7967 2.50049Z",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.097bd2ac9037c605ee7fa71ca99c7419.svg";
export { ForwardRef as ReactComponent };